import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiPlus as PlusIcon } from 'react-icons/hi2';
import { MdPlaylistAddCheck as DocumentCheckIcon } from 'react-icons/md';
import { Badge, Button } from '@knack/asterisk-react';

import { EmptyState } from '@/components/EmptyState';
import { SidePanel } from '@/components/SidePanel';

export function TasksPanel() {
  const [t] = useTranslation();
  const [shouldRenderForm, setShouldRenderForm] = useState(false);

  return (
    <>
      <SidePanel.Header>
        <SidePanel.Title className="text-xl font-medium leading-6" data-testid="tasks-rules-title">
          {t('components.data_table.right_sidebar.tasks.title')}
        </SidePanel.Title>
        <SidePanel.Description className="text-xs">
          {t('components.data_table.right_sidebar.tasks.subtitle')}
        </SidePanel.Description>
      </SidePanel.Header>

      {!shouldRenderForm && (
        <div className="mt-2">
          <EmptyState>
            <EmptyState.Icon icon={<DocumentCheckIcon />} />
            <EmptyState.Description
              className="text-emphasis"
              data-testid="tasks-rules-empty-state-text"
            >
              {t('components.data_table.right_sidebar.tasks.description')}
            </EmptyState.Description>
          </EmptyState>
        </div>
      )}

      {shouldRenderForm ? (
        // TODO: https://knack.atlassian.net/browse/FE-1505
        <div className="-mx-2 mt-2 h-[calc(100%-64px)] overflow-auto px-2">
          <Badge className="px-2 py-0.5 text-xs text-default">{t('keywords.coming_soon')}</Badge>
        </div>
      ) : (
        <Button
          intent="secondary"
          className="mt-4 w-full"
          onClick={() => setShouldRenderForm(true)}
          data-testid="tasks-rule-add-button"
        >
          <Button.Icon icon={PlusIcon} position="left" />
          {t('components.data_table.right_sidebar.tasks.task')}
        </Button>
      )}
    </>
  );
}
